<template>
  <a-modal
    title="操作"
    style="top: 20px;"
    :width="600"
    v-model="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    :footer="false"
    :maskClosable="false"
  >
    <a-form :form="form" @submit="handleSubmit">
      <a-form-item label="姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input
          autocomplete="off"
          :disabled="show"
          v-decorator="['userName', { rules: [{ required: true, message: '请输入姓名' }] }]"
          style="width: 210px;"
        />
      </a-form-item>
      <a-form-item label="联系方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input
          autocomplete="off"
          :disabled="show"
          v-decorator="['phone', { rules: [{ validator: this.isPhone, required: true }] }]"
          style="width: 210px;"
        />
      </a-form-item>
      <a-form-item label="用户名" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input
          autocomplete="off"
          :disabled="show"
          v-decorator="['loginName', { rules: [{ required: true, message: '请输入用户名' }] }]"
          style="width: 210px;"
        />
      </a-form-item>
      <a-form-item v-if="forIn" label="密码" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input
          :disabled="show"
          v-decorator="['password', { rules: [{ required: true, message: '请输入密码' }] }]"
          type="text"
          onfocus="this.type='password'"
          autocomplete="off"
          style="width: 210px;"
        />
      </a-form-item>
      <a-form-item label="登录平台" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-select
          :disabled="show"
          v-decorator="['isPlatform', { rules: [{ required: true, message: '选择登录平台' }] }]"
          style="width: 210px"
          @change="handleChange"
        >
          <a-select-option value="1">
            是
          </a-select-option>
          <a-select-option value="2">
            否
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="角色" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-select
          :disabled="show"
          v-decorator="['roleId', { rules: [{ required: true, message: '请选择角色' }] }]"
          style="width: 210px"
          @change="handleChange"
        >
          < <a-select-option v-for="type in trole" :key="type.roleId">{{ type.roleName }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-row :gutter="24" style="margin: 20px 0">
        <a-col :span="2" v-show="showif">
          <a-button class="twobtn" type="primary" @click="modify">修改密码</a-button>
        </a-col>
      </a-row>
      <a-row :gutter="24" style="margin: 20px 0">
        <a-col :span="24" style="display: flex;">
          <a-button :disabled="show" type="primary" @click="handleSubmit">提交</a-button>
          <a-button style="margin-left: 35px" @click="visible = false">取消</a-button>
        </a-col>
      </a-row>
    </a-form>
    <!--修改密码-->
    <a-modal
      title="修改密码"
      style="top: 20px;"
      :width="800"
      v-model="visible2"
      :confirmLoading="confirmLoading"
      :cancelButtonProps="{ props: { disabled: true } }"
      :closable="false"
      :footer="null"
      @ok="handleSubmit2"
      :maskClosable="false"
    >
      <a-form :form="form2" @submit="handleSubmit2">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="新密码" has-feedback>
          <a-input
            maxLength="20"
            v-decorator="['password', { rules: [{ validator: this.checkPwd, required: true }] }]"
            type="text"
            autocomplete="off"
            onfocus="this.type='password'"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 42%">
          <a-button type="primary" style="margin-right:20px;" @click="handleSubmit2">提交</a-button>
          <a-button @click="visible2 = false">取消</a-button>
          <!--<a-button type="primary" html-type="submit">-->
          <!--Register-->
          <!--</a-button>-->
        </a-form-item>
      </a-form>
    </a-modal>
  </a-modal>
</template>

<script>
import { SubAccountrole, SubAccountadd, resetPwd, Subupdate, SubAccountget } from '@/api/master/TeamManagement'
import pick from 'lodash.pick'
export default {
  name: 'Submodel',
  components: {},
  data() {
    return {
      forIn: false,
      showif: false,
      visible2: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      visible: false,
      queryParam: {},
      form: this.$form.createForm(this),
      form2: this.$form.createForm(this),
      trole: [],
      teamId: '',
      loginName: '',
      userId: '',
      show: true,
      mdl: {},
      falsg: true,
      teamBypassAccountId: ''
    }
  },
  async created() {
    // 权限配置
  },
  methods: {
    isPhone(rule, value, callback) {
      const pwdRegex = /^((0\d{2,3}(-)?\d{7,8})|(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8})$/
      if (value.length == 0) {
        callback(new Error('请输入联系方式'))
      } else if (!pwdRegex.test(value)) {
        callback(new Error('请输入正确的联系方式'))
      }
      callback()
    },
    // 密码校验
    checkPwd(rule, value, callback) {
      const reg = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/]).{8,64}$/
      if (!reg.test(value)) {
        callback(new Error('请输入8位以上密码，必须包含数字、字母、英文特殊字符'))
      } else if (value.length == 0 || value == undefined) {
        callback(new Error('请输入新密码'))
      } else {
        callback()
      }
    },
    modify() {
      this.visible2 = true
    },
    add(id, val, dis, data) {
      //dis=0编辑 1查看 2新增

      this.visible = true
      this.trole = data
      if (dis == 0) {
        SubAccountget(id).then(res => {
          this.teamId = res.data.masterId
          console.log(res.data)
          this.teamBypassAccountId = res.data.teamBypassAccountId
          this.mdl = res.data
          res.data.roleId = Number(res.data.roleId)
          this.$nextTick(() => {
            this.form.setFieldsValue(
              pick(this.mdl, 'userName', 'phone', 'isPlatform', 'loginName', 'password', 'roleId')
            )
          })
        })
        this.falsg = true
        this.forIn = false //密码
        this.showif = true //修改密码
        this.show = false
      } else if (dis == 1) {
        SubAccountget(id).then(res => {
          console.log(res.data)
          this.teamId = res.data.masterId
          this.teamBypassAccountId = res.data.teamBypassAccountId
          this.mdl = res.data
          res.data.roleId = Number(res.data.roleId)
          this.$nextTick(() => {
            this.form.setFieldsValue(
              pick(this.mdl, 'userName', 'phone', 'isPlatform', 'loginName', 'password', 'roleId')
            )
          })
        })
        this.falsg = true
        this.forIn = false //密码
        this.showif = false //修改密码
        this.show = true
      } else if (dis == 2) {
        this.teamId = id
        this.falsg = false
        this.forIn = true //密码
        this.showif = false //修改密码
        this.show = false
        this.form.resetFields()
      }

      this.loginName = val.loginName
      this.userId = val.userId
    },
    handleSubmit(e) {
      e.preventDefault()

      this.form.validateFields((err, values) => {
        if (!err) {
          values.masterId = this.teamId
          if (this.falsg) {
            //编辑
            values.userId = this.userId
            values.teamBypassAccountId = this.teamBypassAccountId
            Subupdate(values).then(res => {
              if (res.code === 0) {
                this.visible = false
                this.$message.success('编辑成功')
                this.$emit('ok')
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            //新增
            SubAccountadd(values).then(res => {
              if (res.code === 0) {
                this.visible = false
                this.$message.success('添加成功')
                this.$emit('ok')
              } else {
                this.$message.error(res.msg)
              }
            })
          }
        }
      })
    },
    handleSubmit2(e) {
      e.preventDefault()
      this.form2.validateFields((err, values) => {
        if (!err) {
          values.loginName = this.loginName
          values.userId = this.userId

          resetPwd(values).then(res => {
            console.log(res)
            if (res.code === 0) {
              this.$message.success('修改成功')
              this.visible2 = false
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.ant-row {
  margin-top: 10px;
}
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  padding: 4px 16px;
}
</style>
